export const baseUrl = "https://admin.firafoods.com";
// export const baseUrl = "http://localhost:8000";

export const config = {
  headers: {
    'Access-Control-Allow-Origin': '*',
  }
};

